import * as yup from 'yup';

import customerIdRegex from '@common/validation/customerIdRegex';
import { emailValidation } from '@common/validation/emailRegex';
import phoneNumberRegex from '@common/validation/phoneNumberRegex';
import type { DeceasedFormRendering } from '@sitecore/types/DeceasedForm';

export const getSchema = (fields: DeceasedFormRendering['fields']) =>
  yup.object({
    recaptchaToken: yup.string().required(),
    deceasedPostalCode: yup.string().required(fields.deceasedFormFields.postalCodeFormField.value.requiredMessage),
    deceasedHouseNumber: yup.string().required(fields.deceasedFormFields.houseNumberFormField.value.requiredMessage),
    deceasedHouseNumberSuffix: yup.string(),
    customerId: yup
      .string()
      .required(fields.deceasedFormFields.customerIdFormField.value.requiredMessage)
      .matches(customerIdRegex, fields.deceasedFormFields.customerIdFormField.value.validationMessage),
    deceasedDate: yup.string().required(fields.deceasedFormFields.deceasedDateFormField.value.requiredMessage),
    endContractDate: yup.string().required(fields.deceasedFormFields.endContractDateFormField.value.requiredMessage),
    contactSalutation: yup.string().required(fields.contactFormFields.salutationFormField.value.requiredMessage),
    contactFirstName: yup.string().required(fields.contactFormFields.firstNameFormField.value.requiredMessage),
    contactSurnamePreposition: yup.string(),
    contactSurname: yup.string().required(fields.contactFormFields.surnameFormField.value.requiredMessage),
    contactPostalCode: yup.string().required(fields.contactFormFields.postalCodeFormField.value.requiredMessage),
    contactHouseNumber: yup.string().required(fields.contactFormFields.houseNumberFormField.value.requiredMessage),
    contactHouseNumberSuffix: yup.string(),
    contactPhoneNumber: yup
      .string()
      .matches(phoneNumberRegex, {
        excludeEmptyString: true,
        message: fields.contactFormFields.phoneNumberFormField.value.validationMessage,
      })
      .required(fields.contactFormFields.phoneNumberFormField.value.requiredMessage),
    contactEmail: emailValidation({
      emailMessage: fields?.contactFormFields?.emailAddressFormField?.value?.validationMessage,
      requiredMessage: fields?.contactFormFields?.emailAddressFormField?.value?.requiredMessage,
    }),
    changePaymentMethod: yup.string().required(fields.footer.changePaymentMethodFormField.value.requiredMessage),
  });
